export function TipsHero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/c7d4e07ef56aace3083184cd7ee8a5a8.jpg"
          alt="Tips for Selling an Apartment Building"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">
              <span className="block text-orange-400">Expert Tips for Selling</span>
              <span className="block text-4xl md:text-5xl mt-4">an Apartment Building</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-12 max-w-4xl mx-auto leading-relaxed">
              Master the art of selling your apartment building with proven strategies from industry experts. 
              Learn how to maximize your sale price, attract qualified buyers, and close deals faster with our 
              comprehensive guide covering everything from preparation to closing.
            </p>

            <div className="flex flex-wrap justify-center gap-6 mb-16">
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
                <div className="text-3xl font-bold text-orange-400 mb-1">10+</div>
                <div className="text-sm">Expert Tips</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
                <div className="text-3xl font-bold text-orange-400 mb-1">$2M+</div>
                <div className="text-sm">Avg. Sale Price</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
                <div className="text-3xl font-bold text-orange-400 mb-1">30-90</div>
                <div className="text-sm">Days to Close</div>
              </div>
            </div>

            <div className="max-w-3xl mx-auto bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                What You'll Learn in This Guide
              </h2>
              <div className="grid md:grid-cols-2 gap-4 text-left text-gray-700">
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>How to prepare your building for maximum value</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Pricing strategies that attract serious buyers</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Marketing tactics for multifamily properties</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Negotiation techniques to maximize profits</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Legal considerations and documentation</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Tax implications and 1031 exchange strategies</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Timing your sale for optimal market conditions</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span>Common mistakes to avoid during the sale</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}